import { Text, View } from '@react-pdf/renderer'
import type React from 'react'

import { PDF_HEADING_MIN_PRESENCE, PdfStyles } from './pdfStyles'

export const PdfSection: React.FC<{
  title: string
  children: React.ReactNode
  keepTogether?: boolean
}> = ({ title, children, keepTogether = false }) => (
  <View style={PdfStyles.sectionCard} wrap={!keepTogether}>
    <Text
      style={PdfStyles.sectionCardTitle}
      wrap={false}
      minPresenceAhead={PDF_HEADING_MIN_PRESENCE}>
      {title}
    </Text>
    <View style={PdfStyles.sectionCardBody}>{children}</View>
  </View>
)
